import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconNightVisionOn = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={25}
      fill="none"
      viewBox="0 0 24 25"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <g clipPath="url(#clip0_4873_3795)">
        <g clipPath="url(#clip1_4873_3795)">
          <path
            d="M17.481 17.322C15.8055 17.3216 14.1535 16.9309 12.6573 16.1811C11.1612 15.4313 9.8627 14.3433 8.86594 13.0044C7.86918 11.6655 7.20193 10.1131 6.91772 8.4715C6.63351 6.82994 6.74026 5.14501 7.2294 3.55188C5.60581 4.29588 4.19528 5.43194 3.12633 6.85657C2.05738 8.2812 1.36398 9.94909 1.10932 11.7083C0.854663 13.4675 1.04683 15.2621 1.66832 16.9286C2.2898 18.5951 3.32085 20.0805 4.66753 21.2494C6.0142 22.4184 7.63369 23.2338 9.37845 23.6213C11.1232 24.0088 12.9378 23.9561 14.6568 23.4681C16.3758 22.98 17.9447 22.072 19.2205 20.8269C20.4962 19.5818 21.4383 18.1139 21.9609 16.4142C20.5571 17.0614 19.0284 17.3219 17.481 17.322Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.6855 10.9497C12.3895 10.9497 11.4295 9.98372 11.4295 8.77772V8.76572C11.4295 7.55972 12.4015 6.58172 13.6975 6.58172C14.9935 6.58172 15.9535 7.54772 15.9535 8.75372V8.76572C15.9535 9.97172 14.9815 10.9497 13.6855 10.9497ZM13.6975 9.89972C14.3335 9.89972 14.7595 9.38372 14.7595 8.77772V8.76572C14.7595 8.15372 14.3275 7.63172 13.6855 7.63172C13.0435 7.63172 12.6175 8.14772 12.6175 8.75372V8.76572C12.6175 9.37172 13.0555 9.89972 13.6975 9.89972ZM16.3078 10.8657V7.61972H17.4478V8.07572C17.6578 7.80572 17.9578 7.54772 18.4198 7.54772C19.1098 7.54772 19.5238 8.00372 19.5238 8.74172V10.8657H18.3898V9.10772C18.3898 8.74772 18.2038 8.55572 17.9278 8.55572C17.6518 8.55572 17.4478 8.74772 17.4478 9.10772V10.8657H16.3078Z"
            fill="currentColor"
          />
        </g>
      </g>
    </SvgIcon>
  );
};
